/**
 * 基于 swiper 插件的轮播及滑动效果。使用前必须在HTML文件中引入 swiper.min.js。
 * @param {String} selector swiper容器的选择器
 * @param {Object} options swiper参数
 */
export function init ({ selector = '.swiper-container', options = {} } = {}) {
  let opts = {
    autoplay: {
      delay: 7000, //可选选项，自动滑动
      disableOnInteraction: false
    },
    initialSlide: 0,
    observer: true,
    observeParents: true,
    paginationElement: 'li',
    resistance : true,
    resistanceRatio: 0.85
  }
  let objArr = []

  Object.assign(opts, options)

  if (!(selector instanceof Array) && typeof selector !== 'string') {
    return utils.log.e('[swiper][init] invalid argument: selector', selector)
  }

  if (selector instanceof Array) {
    for (let obj of selector) {
      obj = new Swiper(obj, opts)
      objArr.push(obj)
    }
  } else {
    objArr.push(new Swiper(selector, opts))
  }

  return objArr
}


// WEBPACK FOOTER //
// ./js/animation/swiper/init.js